import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MdMenuTrigger } from '@angular/material';
import { NegociosHeaderComponent } from '../header';
import { DateTimePipe, PricePipe, TnsPipe } from '@utils/pipes';
import { parseDate } from '@utils/DateHelper';
import { SpinnerService } from '@services/spinner-service';
import { DialogsService } from '@services/dialogs-service';
import { SignalrService } from '../../../signalr/signalR.service';
import {
  NegociosService,
  NEGOCIO_TYPE_ORDEN,
  NEGOCIO_TYPE_INTENCION,
  NEGOCIO_TYPE_ORDEN_ID,
  NEGOCIO_TYPE_INTENCION_ID,
  NEGOCIO_TYPE_DISPO,
  NEGOCIO_TYPE_FORWARD,
  CONFIRMACION_VALUES,
  NEGOCIO_TYPE_PAGO_DIFERIDO, getFuenteName
} from '@services/negocios-service';
import { PATH_NEGOCIOS, PATH_NEGOCIO_DETAIL } from '../../../navigation/navigation.module';

import * as moment from 'moment';
import { PreciosService } from '@services/precios-service';
import { ColaboradoresService } from '@services/colaboradores-service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { NegociosKanbanComponent } from '../negocios-kanban';
import { TableroNegociosComponent } from '../tablero-negocios';
import { PermisosService, NEG_ACTIONS, PERM_ACCIONES_ID } from '@services/permisos-service';
import {FirebaseMessagingService} from '@services/firebase-messaging.service';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-negocios',
  templateUrl: './negocios.component.html',
  styleUrls: ['./negocios.component.scss']
})
export class NegociosComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('topScroller') topScroller: ElementRef;
  @ViewChild('table') table: ElementRef;
  @ViewChild('tableHeader') tableHeader: ElementRef;
  @ViewChild('quickFilters') quickFilters: ElementRef;
  @ViewChild(NegociosKanbanComponent) kanban;
  @ViewChild(TableroNegociosComponent) tablero;
  @ViewChild(MdMenuTrigger) triggerMenu: MdMenuTrigger;

  @Input() parent: NegociosHeaderComponent;

  // Este componente también se usa como parte del simulador en la carga de precios. Hay algunas funcionalidades
  // que difieren si se usa de esa manera. Para saber en qué modo estamos se usa este flag.
  @Input() simulator: boolean = false;
  // Este es el payload request para el simulador
  @Input() payload: any = [];

  // También se usa como tab dentro del detalle de una cuenta
  @Input() cuenta: any = null;

  columns = [
    'hora', 'confirmación', 'fecha-estado', 'tipo', 'cliente', 'producto', 'tns', 'negocio', 'entrega', 'cosecha', 'moneda', 'base', 'precio',
    'precio-especial', 'match', 'autorizante', 'responsable', 'acopio', 'zona', 'vencimiento', 'fecha', 'mercado', 'fuente'
  ];
  // Columnas que usan un título no deducible desde su id en this.columns
  needSpecialName = {'precio': 'Precio / Idea', 'hora': 'Marca Temporal', 'confirmación': 'Estado', 'fecha': 'Creación'};
  // Columnas cuyo título en modal de filtro difiere de su título en la tabla
  needSpecialFilterName = {'tns': 'Toneladas'};

  // Columnas con tipo de dato desde/hasta en números
  fromToColumns = ['tns', 'base', 'precio', 'precio-especial'];
  // Columnas con tipo de dato autocompletar
  arrayColumns = ['cliente', 'responsable', 'acopio'];


  verticalScroll;

  // Fila elegida actualmente. -1 significa ninguno seleccionado
  public selectedRegister: number = -1;

  sortTimeout;

  // Columna de sorting elegida actualmente
  sortColumn: string = 'hora';

  sortOrder = {};

  showQuickFiltersKanban: boolean = false;

  filters = {};
  showQuickFilters: boolean = false;
  chips = [];
  quickFiltersModels = {
    Hoy: false,
    Ordenes: false,
    Intenciones: false,
    Matches: false,
    Confirmadas: false,
    Vencidas: false
  };
  quickFiltersModelsTmp:any = {};

  public rows = [];

  negociosPage: number = 0;

  metricasValues: any = {};

  DEFAULT_DAYS_FILTER: number = 15;

  NEGOCIO_TYPE_INTENCION_ID = NEGOCIO_TYPE_INTENCION_ID;

  public viewIndex = 0;

  // paginador
  public pageSize = 25;
  public currentPage = 0;
  public resultsPageCount = 0;
  public resultsFullCount = 0;
  public marginLeft = '0px';

  spinnerValue: boolean;
  loadingNegocios = false;

  highLightTimeout = null;
  NEG_ACTIONS = NEG_ACTIONS;
  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  getFuenteName = getFuenteName;

  destroyedSubject = new Subject();

  constructor(private router: Router,
              private spinnerService: SpinnerService,
              private dialogsService: DialogsService,
              private pricePipe: PricePipe,
              private dateTimePipe: DateTimePipe,
              private tonsPipe: TnsPipe,
              private negociosService: NegociosService,
              private signalRService: SignalrService,
              private detector: ChangeDetectorRef,
              private preciosService: PreciosService,
              private colaboradorService: ColaboradoresService,
              private location: Location,
              private route: ActivatedRoute,
              private permisosService: PermisosService,
              private firebaseService: FirebaseMessagingService,
  ) { }

  ngOnInit() {

    this.route.params.take(1).subscribe(params => {
      const page = this.route.snapshot.params['page'];
      if (page === 'kanban') {
        this.viewIndex = 1;
      } else if (page === 'tablero') {
        this.viewIndex = 2;
      }
    });

    this.spinnerService.showFlag$.takeUntil(this.destroyedSubject).subscribe(x => {
      this.spinnerValue = x;
    });

    if (this.simulator) {
      this.columns = [
        'actualizar', 'fecha', 'fecha-estado', 'tipo', 'cliente', 'producto', 'tns', 'negocio', 'entrega', 'cosecha', 'moneda', 'base', 'precio',
        'responsable', 'acopio', 'vencimiento', 'mercado'
      ];
    }
    if (this.cuenta) {
      this.columns = this.columns.filter(c => c !== 'cliente');
    }

    // Inicializar sort order
    this.columns.forEach(key => {
      this.sortOrder[key] = 0;
    });

    // Filtros y sorting aplicados
    if (!this.simulator && !this.cuenta) {
      const settings = this.negociosService.getListSettings();
      if (settings) {
        this.quickFiltersModels = {...settings.quickFilters};
        this.filters = {...settings.filters};
        if (settings.sortOrder) {
          this.sortOrder = {...settings.sortOrder};
        }
        if (settings.sortColumn) {
          this.sortColumn = settings.sortColumn;
        }
      } else {
        // Traer por defecto los negocios activos, matcheados o en proceso. A menos que se toquen los filtros
        this.filters = {
          'confirmación': this.negociosService.getConfirmacionOptions()
            .filter(o => [
              CONFIRMACION_VALUES.ACTIVA,
              CONFIRMACION_VALUES.MATCHEADA,
              CONFIRMACION_VALUES.EN_PROCESO,
              CONFIRMACION_VALUES.CONFIRMADA,
              CONFIRMACION_VALUES.GENERACION_AVISO,
              CONFIRMACION_VALUES.AVISO_GENERADO,
              CONFIRMACION_VALUES.FINALIZADO
              ].indexOf(o.Value) >= 0),
          'hora': {
            startDate: moment().subtract(this.DEFAULT_DAYS_FILTER, 'day').startOf('day').toDate(),
            endDate: moment().endOf('day').toDate(),
          }
        };
      }
      this.buildChips();
    }

    if (this.cuenta) {
      this.filters = {cliente: [this.cuenta]};
    }

    if (this.simulator) {
      this.spinnerService.setShowFlag(true);
      this.loadingNegocios = true;
      this.preciosService.simulatePrecios(this.payload).take(1).subscribe(response => {
          // this.rows = response.ResponseData.Negocios || [];
          // this.metricasValues = response.ResponseData.Metricas || {};
          if (this.rows.length) {
            this.rows.forEach(x => {
              x.needUpdate = x.Confirmacion.Estado === CONFIRMACION_VALUES.CONFIRMADA || x.Confirmacion.Estado === CONFIRMACION_VALUES.MATCHEADA;
              x.updatePriceCheck = false;
            });
            this.sortSimuladorRows();
          }
          this.loadingNegocios = false;
          this.spinnerService.setShowFlag(false);
        },
        err => this.spinnerService.setShowFlag(false)
      );
    } else {
      this.getNegocios();
    }

    this.signalRService.newNegocioMessage.takeUntil(this.destroyedSubject).subscribe(x => this.newNegocio(this, x));
  }

  newNegocio(self: NegociosComponent, negocio: any) {
    if (negocio && !this.simulator && this.negociosService.negociosLastSignalRID !== negocio.Id) {
      this.negociosService.negociosLastSignalRID = negocio.Id;
      const index = self.rows.findIndex(val => val.Id === negocio.Id);
      if (index >= 0) {
        self.rows.splice(index, 1);
      }
      negocio['isNew'] = true;
      this.disableHightLight();
      self.rows.unshift(negocio);
    }
    // If de paranoia: nos cubrimos ante cualquier situación en donde este método se ejecute cuando la vista
    // ya se ha destruido
    if (!self.detector['destroyed']) {
      self.detector.detectChanges();
    }
  }

  getNegocios(page: number = 0) {
    const fechaDesde = this.filters['fecha'] ? this.filters['fecha'].startDate : moment().subtract(this.DEFAULT_DAYS_FILTER, 'days').startOf('day').toDate();
    const fechaHasta = this.filters['fecha'] ? this.filters['fecha'].endDate : moment().endOf('day').toDate();
    this.loadingNegocios = true;
    this.spinnerService.setSoftSpinnerShowFlag(true);
    this.negociosService.getNegocios(
      page,
      fechaDesde,
      fechaHasta,
      this.getSortColumnTitle(this.sortColumn),
      this.sortOrder[this.sortColumn],
      this.filters,
      this.quickFiltersModels,
      this.pageSize
    ).take(1).subscribe(res => {
        this.rows = res.ResponseData;
        this.resultsPageCount = this.rows.length ? this.rows[0].CantidadPaginas : 0;
        this.resultsFullCount = this.rows.length ? this.rows[0].CantidadNegocios : 0;
        if (res.ResponseData.length) {
          this.negociosPage = page + 1;
        }
        this.loadingNegocios = false;
        this.spinnerService.setSoftSpinnerShowFlag(false);
      }, err => {
        this.loadingNegocios = false;
        this.spinnerService.setSoftSpinnerShowFlag(false);
      }
    );

    // Metricas no está paginado. Solo se consulta al cambiar los filtros y devuelve los totales
    if (page === 0) {
      this.negociosService.getMetricas(
        moment().subtract(this.DEFAULT_DAYS_FILTER, 'days').startOf('day').toDate(),
        moment().endOf('day').toDate(),
        this.getSortColumnTitle(this.sortColumn),
        this.sortOrder[this.sortColumn],
        this.filters,
        this.quickFiltersModels
      ).take(1).subscribe(res => {
        if (page === 0) {
          // this.metricasValues = res.ResponseData;
        }/* else {
          Object.keys(this.metricasValues).forEach(m => {
            this.metricasValues[m] += res.ResponseData[m];
          });
        }*/
        Object.keys(this.metricasValues).forEach(m => {
          this.metricasValues[m] = Math.floor(this.metricasValues[m] * 1000) / 1000;
        });
      });
    }
  }

  ngAfterViewInit() {
    if (!this.simulator) {
      if (this.parent) {
        // this.parent.tabNegocio = this;
      }

      // CUSTOM VERTICAL SCROLL CON STICKY HEADER
      this.verticalScroll = window.document.querySelector('.mat-drawer-content');

      // No podemos usar @HostListener('document:scroll'... porque el scroll vertical no está en el documento
      // sino en el div .mat-drawer-content
      this.verticalScroll.addEventListener('scroll', e => {
        if (this.tableHeader) {
          const extra = this.quickFilters.nativeElement.offsetHeight;
          const tableHeaderBase = -67;

          // Los valores de scroll son distintos si estamos dentro del tab Negocio en detalle de una cuenta o si estamos en la sección Negocios propiamente dicha
          const tableHeaderBaseScroll = -188 - 67 - (this.cuenta ? 154 : 0);
          const topScrollerBaseScroll = -186 - (this.cuenta ? 154 : 0);
          const scrollStartPoint = 185 + (this.cuenta ? 154 : 0);

          if (this.verticalScroll.scrollTop > scrollStartPoint + extra) {
            this.tableHeader.nativeElement.style.top = (this.verticalScroll.scrollTop + tableHeaderBaseScroll - extra) + 'px';
            this.topScroller.nativeElement.style.top = (this.verticalScroll.scrollTop + topScrollerBaseScroll - extra) + 'px';
          } else {
            this.tableHeader.nativeElement.style.top = tableHeaderBase + 'px';
            this.topScroller.nativeElement.style.top = '0px';
          }
        }
      });

    } else {
      // CUSTOM VERTICAL SCROLL CON STICKY HEADER
      this.verticalScroll = window.document.querySelector('.simulator-vertical-scroll');

      this.verticalScroll.addEventListener('scroll', e => {
        const url = location.href.substr(location.href.lastIndexOf('/') + 1);
        if (url !== PATH_NEGOCIOS) return;

        const extra = this.quickFilters.nativeElement.offsetHeight;
        const tableHeaderBase = -67;
        const tableHeaderBaseScroll = -70;
        const scrollStartPoint = 68;

        if (this.verticalScroll.scrollTop > scrollStartPoint + extra) {
          this.tableHeader.nativeElement.style.top = (this.verticalScroll.scrollTop + tableHeaderBaseScroll - extra) + 'px';
        } else {
          this.tableHeader.nativeElement.style.top = tableHeaderBase + 'px';
        }
      });
    }
  }

  onScroll(e) {
    // Con esta técnica simulamos un scroll horizontal que está arriba del div en cuestión (recordemos que html por defecto deja
    // el scroll horizontal por DEBAJO de dicho div. Nosotros ocultamos ese scroll y agregamos uno arriba que usa este listener)
    // No olvidar que el elemento a scrollear artificialmente debe tener overflow: hidden u overflow: auto y ser un div cuyo contenido
    // tenga ancho definido
    this.table.nativeElement.scrollLeft = e.target.scrollLeft;
    this.marginLeft = e.target.scrollLeft.toString() + 'px';
  }

  selectRegister(e, index, deselect = true) {
    if (!this.simulator) {
      if (index !== this.selectedRegister) {
        this.selectedRegister = index;
      } else if (deselect) {
        this.selectedRegister = -1;
      }
    }
  }

  accessRegister(index?) {
    if (!this.simulator) {
      this.router.navigate([PATH_NEGOCIO_DETAIL, this.rows[this.selectedRegister >= 0 ? this.selectedRegister : index].Id]);
    }
  }

  openFilterModal(column) {
    if (!this.simulator) {
      if (this.showQuickFilters) {
        this.toggleQuickFilters();
      }

      clearTimeout(this.sortTimeout);
      const title = this.needSpecialFilterName[column] || this.getColumnTitle(column);
      this.dialogsService.showNegociosFilterDialog(column, title, this.filters)
        .take(1).subscribe((res: any) => {
          if (res) {
            this.filters = res.filters;

            // Si elegimos Guardar pero no cargamos ninguna info en este filtro, lo quitamos
            if (this.fromToColumns.indexOf(column) >= 0) {
              if (typeof this.filters[column].model1 !== 'number' && typeof this.filters[column].model2 !== 'number') {
                delete this.filters[column];
              }
            } else if (this.arrayColumns.indexOf(column) >= 0) {
              if (!this.filters[column] || this.filters[column].length === 0) {
                delete this.filters[column];
              }
            }

            if (this.filters['fecha']) {
              this.quickFiltersModels.Hoy = false;
            }
            if (this.filters['tipo']) {
              this.quickFiltersModels.Ordenes = false;
              this.quickFiltersModels.Intenciones = false;
              this.quickFiltersModels.Confirmadas = false;

              // primero generamos un array de estados con los estados posibles para los filtros elegidos
              let estados = [];
              this.filters['tipo'].forEach(x => {
                estados = [...estados, ...this.negociosService.getConfirmacionOptionsByTipo()[x.ID].map(o => o.ID)];
              });

              // si en el filtro confirmacion, hay algun estado que no se puede dar por el filtro anterior, sacarlo
              // Si cambiamos a una intención, por ejemplo, y en Estado teníamos filtrado por 'Confirmadas' ya no tiene sentido. Debemos quitar ese filtro

              // const tmp = this.negociosService.getConfirmacionOptionsByTipo()[this.filters['tipo'].model1].map(o => o.ID);
              if (this.filters['confirmación']) {
                this.filters['confirmación'] = this.filters['confirmación'].filter(o => estados.indexOf(o.ID) >= 0);

                // Y si después de quitar los filtros no válidos quedó vacío, entonces debemos quitarlo del objeto.
                if (this.filters['confirmación'].length === 0) {
                  delete this.filters['confirmación'];
                }
              }
            } else if (!this.filters['tipo'] && res.column === 'tipo') {
              this.quickFiltersModels.Ordenes = false;
              this.quickFiltersModels.Intenciones = false;
            }
            if (this.filters['match']) {
              this.quickFiltersModels.Matches = false;
            }
            if (this.filters['confirmación'] || (res.column === 'confirmación' && res.todos)) {
              this.quickFiltersModels.Confirmadas = false;
              this.quickFiltersModels.Vencidas = false;
            }
            this.quickFiltersModelsTmp = {...this.quickFiltersModels};

            // Si agregamos o quitamos filtros se dispara una nueva búsqueda
            this.applyFilters();
          }

          this.buildChips();
        }
      );
    }
  }

  toggleQuickFilters() {

    if (this.viewIndex === 0 && !this.simulator) {

      this.showQuickFilters = !this.showQuickFilters;
      this.showQuickFiltersKanban = false;
      this.quickFiltersModelsTmp = {...this.quickFiltersModels};

    } else if (this.viewIndex === 1) {

      this.showQuickFiltersKanban = !this.showQuickFiltersKanban;
      this.showQuickFilters = false;

    } else if (this.viewIndex === 2) {

      this.showQuickFiltersKanban = false;
      this.showQuickFilters = false;
      this.tablero.toggleFilters();
    }
  }

  buildChips() {
    // Si estamos en el tab Negocio dentro del detalle de una cuenta, no mostramos el chip de cuenta
    this.chips = Object.keys(this.filters).filter(c => c !== 'cliente' || !this.cuenta).map(key => {
      let value = '';
      switch (key) {
        case 'fecha':
        case 'hora':
        case 'vencimiento':
        case 'fecha-estado':
          value = moment(this.filters[key].startDate).format('DD-MM-YY') + ' al ' + moment(this.filters[key].endDate).format('DD-MM-YY');
          break;
        case 'producto':
        case 'negocio':
        case 'entrega':
        case 'cosecha':
        case 'moneda':
        case 'mercado':
          value = this.filters[key].model1Value;
          break;
        case 'confirmación':
          if (this.filters['confirmación'].length <= 4) {
            value = this.filters['confirmación'].reduce((acc, o) => {
              const v = o.Value === CONFIRMACION_VALUES.EN_PROCESO ? 'En proceso' : o.Value;
              return acc + (acc.length ? ', ' : '') + v;
            }, '');
          } else {
            value = 'Varios';
          }
          break;
        case 'tipo':
          if (this.filters['tipo'].length <= 4) {
            this.filters['tipo'].forEach(x => {
              let temp = x.Tipo_Negocio;
              if (x.ID === 5) {
                temp = 'Aviso Generado';
              }
              value = value + temp + ', ';
            });
            value = value.slice(0, -2);
          } else {
            value = 'Varios';
          }
          break;
        case 'cliente':
          if (this.filters['cliente'].length === 1) {
            value = this.filters['cliente'][0].FullName;
          } else {
            value = 'Varios';
          }
          break;
        case 'responsable':
          if (this.filters['responsable'].length === 1) {
            value = this.filters['responsable'][0].UserFullName;
          } else {
            value = 'Varios';
          }
          break;
        case 'autorizante':
          if (this.filters['autorizante'].model1 === 'AUTO') {
            value = 'Automático';
          } else if (this.filters['autorizante'].model2.length === 1) {
            value = this.filters['autorizante'].model2[0].UserFullName;
          } else {
            value = 'Varios';
          }
          break;
        case 'acopio':
          if (this.filters['acopio'].length === 1) {
            value = this.filters['acopio'][0].AcopioNombre;
          } else {
            value = 'Varios';
          }
          break;
        case 'tns':
        case 'base':
        case 'precio':
        case 'precio-especial':
          value = this.filters[key].model1 + '-' + this.filters[key].model2;
          break;
        case 'match':
          value = this.filters['match'].model1 ? 'Sí' : 'No';
          break;
        case 'zona':
          if (this.filters['zona'].length === 1) {
            value = this.filters['zona'][0].Categoria;
          } else {
            value = 'Varios';
          }
          break;
        case 'fuente':
          value = getFuenteName(this.filters['fuente'].model1);
          break;
      }

      return {
        col: key,
        title: this.getColumnTitle(key),
        value
      };
    });
  }

  applyFilters(quick: boolean = false) {
    if (quick) {
      this.showQuickFilters = false;

      if ((this.quickFiltersModelsTmp.Hoy !== this.quickFiltersModels.Hoy) || this.quickFiltersModelsTmp.Hoy) {
        delete this.filters['fecha'];
      }
      if ((this.quickFiltersModelsTmp.Ordenes !== this.quickFiltersModels.Ordenes) ||
          (this.quickFiltersModelsTmp.Intenciones !== this.quickFiltersModels.Intenciones)) {
        delete this.filters['tipo'];
      }
      if ((this.quickFiltersModelsTmp.Matches !== this.quickFiltersModels.Matches) || this.quickFiltersModelsTmp.Matches) {
        delete this.filters['match'];
      }
      if ((this.quickFiltersModelsTmp.Confirmadas !== this.quickFiltersModels.Confirmadas) ||
          (this.quickFiltersModelsTmp.Vencidas !== this.quickFiltersModels.Vencidas)) {
        delete this.filters['confirmación'];
      }

      this.quickFiltersModels = {...this.quickFiltersModelsTmp};
      this.buildChips();
    }

    if (!this.simulator && !this.cuenta) {
      this.negociosService.saveListSettings(
        this.quickFiltersModels,
        this.filters,
        this.sortOrder,
        this.sortColumn
      );
    }

    this.selectedRegister = -1;
    this.getNegocios(0);
  }

  sortByColumn(column, immediate) {
    if (!this.simulator) {
      clearTimeout(this.sortTimeout);
      this.sortTimeout = setTimeout(() => {
        if (this.sortColumn === column) {
          this.sortOrder[column] = (this.sortOrder[column] + 1) % 2;
        } else {
          this.sortOrder[column] = this.sortOrder[column] || 0;
        }
        this.sortColumn = column;

        if (!this.cuenta) {
          this.negociosService.saveListSettings(
            this.quickFiltersModels,
            this.filters,
            this.sortOrder,
            this.sortColumn
          );
        }

        this.selectedRegister = -1;
        this.getNegocios(0);
      }, immediate ? 0 : 250);
    }
  }

  getColumnTitle(col) {
    return this.needSpecialName[col] ||
      col.split('-').map(w => w.length ? w[0].toUpperCase() + w.slice(1) : '').join(' ');
  }

  getSortColumnTitle(col) {
    const specialNames = {
      'tns': 'Toneladas',
      'precio': 'PrecioIdea',
      'precio-especial': 'PrecioEspecial',
      'confirmación': 'Confirmacion',
      'hora': 'HoraConfirmacion',
      'fecha-estado': 'FechaEstado'
    };

    return specialNames[col] || col[0].toUpperCase() + col.substr(1);
  }

  // Check status filter integrity
  checkStFilterIntegrity() {
    if (!this.quickFiltersModelsTmp.Ordenes && this.quickFiltersModelsTmp.Intenciones) {
      this.quickFiltersModelsTmp.Confirmadas = false;
    }
  }

  getColumnValue(row, col) {
    switch (col) {
      case 'fecha':
        return row.Fecha ? this.dateTimePipe.transform(parseDate(row.Fecha), 'dd/mm/yyyy hh:mm') : '-';
      case 'tipo':
        return row.TipoNegocio ? row.TipoNegocio.Tipo : '-';
      case 'fecha-estado':
        return row.Confirmacion.FechaEstado ? moment.unix(row.Confirmacion.FechaEstado).format('DD/MM/YYYY hh:mm') : '-';
      case 'cliente':
        return row.Cliente ? row.Cliente.FullName : '-';
      case 'producto':
        return row.Producto ? row.Producto.Producto : '-';
      case 'tns':
        return row.Toneladas ? this.tonsPipe.transform(row.Toneladas) : '-';
      case 'negocio':
        return row.Entrega ? (row.Entrega.EsPosicion ? NEGOCIO_TYPE_FORWARD : (row.Entrega.Id === 4 ? NEGOCIO_TYPE_PAGO_DIFERIDO : NEGOCIO_TYPE_DISPO)) : '-';
      case 'entrega':
        return row.Entrega ? (row.Entrega.EsPosicion ? row.NegocioTipoPosicion.NegocioTipoPosicion : (row.Entrega.Id === 4 ? row.NegocioTipoPosicion.NegocioTipoPosicion : row.Entrega.Entrega)) : '-';
      case 'cosecha':
        return row.Cosecha ? row.Cosecha.Cosecha : '-';
      case 'moneda':
        return row.Moneda ? row.Moneda.Simbolo : '-';
      case 'base':
        return row.Base ? this.pricePipe.transform(row.Base) : '-';
      case 'precio':
        if (row.PrecioIdea) {
          return this.pricePipe.transform(row.PrecioIdea);
        } else if (row.PrecioIdeaMatch) {
          return this.pricePipe.transform(row.PrecioIdeaMatch);
        } else {
          return '-';
        }
      case 'precio-especial':
        return row.PrecioEspecial ? this.pricePipe.transform(row.PrecioEspecial) : '-';
      case 'match':
        return row.Match ? 'Sí' : 'No';
      case 'confirmación':
        return row.Confirmacion && row.Confirmacion.Estado;
      case 'hora':
        return this.dateTimePipe.transform(parseDate(row.FechaModificacion), 'dd/mm/yyyy hh:mm');
      case 'responsable':
        return row.Responsable ? row.Responsable.UserFullName : '-';
      case 'autorizante':
        if ([CONFIRMACION_VALUES.CONFIRMADA, CONFIRMACION_VALUES.AUTORIZADA,
             CONFIRMACION_VALUES.NO_AUTORIZADA,
             CONFIRMACION_VALUES.MATCHEADA].indexOf(row.Confirmacion && row.Confirmacion.Estado) >= 0) {
          return row.Confirmacion && row.Confirmacion.Automatico === true ? 'Automático' : (row.Autorizante.UserFullName || '');
        } else {
          return '';
        }
      case 'acopio':
        return row.Acopio ? row.Acopio.AcopioNombre : '-';
      case 'vencimiento':
        return row.Vencimiento ? this.dateTimePipe.transform(parseDate(row.Vencimiento), 'dd/mm/yyyy') : '-';
      case 'zona':
        return row.Zona ? row.Zona : '-';
      case 'mercado':
        return row.Mercado ? row.Mercado.Mercado : '-';
      default:
        return '';
    }
  }

  getOppositeType() {
    if (this.selectedRegister >= 0) {
      return this.getColumnValue(this.rows[this.selectedRegister], 'tipo') === NEGOCIO_TYPE_INTENCION ?
              NEGOCIO_TYPE_ORDEN :
              NEGOCIO_TYPE_INTENCION;
    } else {
      return '';
    }
  }

  getConfirmacionClass(row) {
    if (!row.Confirmacion) {
      return '';
    }
    let name = row.Confirmacion.Estado.split(' ').map(w => w.toLowerCase()).slice(0,2).join('-');

    // El color para estos dos estados difieren en caso de que sea una intención o una orden
    if ((name === 'vencida' || name === 'activa') &&
        this.getColumnValue(row, 'tipo') === NEGOCIO_TYPE_INTENCION)
    {
      name += '2';
    }

    return name;
  }

  contextMenu(e, index) {
    if (!this.simulator) {
      e.preventDefault();

      this.selectRegister(e, index, false);

      this.triggerMenu.openMenu();

      setTimeout(_ => {
        const list = document.getElementsByClassName('negocios-context-menu');

        if (list) {
          const elem: any = list[0];
          elem.style.left = e.clientX + 'px';
          elem.parentElement.style.position = 'static';

          // Si hay espacio para desplegar el menú hacia abajo lo hacemos, sino lo desplegamos hacia arriba
          if (window.innerHeight - e.clientY >= elem.offsetHeight) {
            elem.style.top = e.clientY + 'px';
          } else {
            elem.style.top = e.clientY - elem.offsetHeight + 20 + 'px';
          }
        }
      }, 10);

      return false;
    }
  }

  onSwapNegocioType() {
    this.dialogsService.confirm(null,
                '¿Está seguro de que quiere cambiar el tipo de este negocio?',
                'SÍ, CAMBIAR',
                'NO, CANCELAR')
      .take(1)
      .subscribe( res => {
        if (res) {
          const index = this.selectedRegister;
          // Cambiar el tipo de negocio en el listado
          if (this.rows[index].TipoNegocio.Tipo === NEGOCIO_TYPE_INTENCION) {
            this.rows[index].TipoNegocio.Tipo = NEGOCIO_TYPE_ORDEN;
            this.rows[index].TipoNegocio.Id = NEGOCIO_TYPE_ORDEN_ID;
          } else {
            this.rows[index].TipoNegocio.Tipo = NEGOCIO_TYPE_INTENCION;
            this.rows[index].TipoNegocio.Id = NEGOCIO_TYPE_INTENCION_ID;
          }
          // Y en la API
          this.negociosService.swapNegocioType(this.rows[index].Id).take(1).subscribe(x => {});
        }
      });
  }

  removeFilter(chip) {
    this.chips = this.chips.filter(c => c.col !== chip.col);
    delete this.filters[chip.col];
  }

  onCreateNewNegocio() {
    this.dialogsService.showNewNegocioDialog(null)
      .take(1).subscribe(value => {
        if (value) {
          this.selectedRegister = -1;
          this.getNegocios(0);
        }
      });
  }

  onEditNegocio() {
    this.dialogsService.showNewNegocioDialog(this.rows[this.selectedRegister].Id)
      .take(1).subscribe(value => {
        if (value) {
          this.selectedRegister = -1;
          this.currentPage = 0;
          this.getNegocios();
        }
      });
  }

  onDuplicateNegocio() {
    this.dialogsService.showNewNegocioDialog(this.rows[this.selectedRegister].Id, true)
      .take(1).subscribe( (value) => {
        if (value) {
          this.selectedRegister = -1;
          this.currentPage = 0;
          this.getNegocios();
        }
      });
  }

  onDeleteNegocio() {
    this.dialogsService.showTextAreaDialog(
                '¿Está seguro de que desea anular este negocio?', null,
                'SÍ, ANULAR',
                'NO, CANCELAR', true)
      .take(1).subscribe(res => {
        if (res) {
          // Guardar el índice en caso de que el usuario haga click en otra fila antes de que el borrado vuelva desde la API
          const index = this.selectedRegister;

          this.spinnerService.setShowFlag(true);
          this.negociosService.deleteNegocio(this.rows[this.selectedRegister].Id, res).take(1).subscribe(_ => {
            this.rows.splice(index, 1);

            // Si el selectedRegister sigue siendo el que borramos le asignamos -1 (esto es: ninguno seleccionado)
            if (this.selectedRegister === index) {
              this.selectedRegister = -1;
            }

            this.spinnerService.setShowFlag(false);
          }, err => this.spinnerService.setShowFlag(false));
        }
      });
  }

  onClickPrecioEspecial(e, row) {
    // Evitar seleccionar la fila al hacer click en precio especial
    e.stopPropagation();
    if (row.Confirmacion.Estado === CONFIRMACION_VALUES.ACTIVA ||
        row.Confirmacion.Estado === CONFIRMACION_VALUES.MATCHEADA ||
        row.Confirmacion.Estado === CONFIRMACION_VALUES.AUTORIZADA ||
        row.Confirmacion.Estado === CONFIRMACION_VALUES.CONFIRMADA) {
      this.dialogsService.showPrecioEspecialDialog({price: row.PrecioEspecial, currency: row.Moneda.Simbolo}, true).take(1).subscribe((res: any) => {
        if (res && res.price >= 0) {
          // Guardarlo en la db y actualizarlo en nuestra copia local
          const newPrice = res.price || 0;
          // row.PrecioEspecial = newPrice;
          this.spinnerService.setShowFlag(true);
          this.negociosService.addSpecialPrice(row.Id, newPrice).take(1).subscribe(_ => {
            this.spinnerService.setShowFlag(false);
            this.selectedRegister = -1;
            this.getNegocios(0);
          }, err => this.spinnerService.setShowFlag(false));
        }
      });
    } else {
      this.viewPriceDetail(row);
    }
  }

  viewPriceDetail(row) {
    this.dialogsService.showPrecioEspecialDialog({
      fecha: moment(row.Confirmacion.FechaEstado * 1000).format('DD/MM/YY HH.mm') + 'hs',
      responsable: row.Confirmacion.UsuarioEstado
    }, false);
  }

  showPrecioEspecialButton(c) {
    return c && this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_CrearPrecioEspecial) &&
     (c.Estado === CONFIRMACION_VALUES.ACTIVA ||
      c.Estado === CONFIRMACION_VALUES.MATCHEADA ||
      c.Estado === CONFIRMACION_VALUES.AUTORIZADA ||
      c.Estado === CONFIRMACION_VALUES.CONFIRMADA);
  }

  ngOnDestroy(): void {
    this.destroyedSubject.next();
  }

  showNegocioButton(accion) {
    if (this.selectedRegister >= 0) {
      return this.permisosService.showNegocioAction(accion, this.rows[this.selectedRegister].Confirmacion.Estado, this.rows[this.selectedRegister].TipoNegocio.Id);
    }
    return false;
  }

  // voids para simulador y actualizacion de precios
  onUpdateCkeckChanged(row, e) {
    row.updatePriceCheck = e.checked;
  }

  sortSimuladorRows() {
    if (this.rows.length) {
      // hacer un sort para tener las filas que necesitan actualizacion arriba
      this.rows.sort((a, b) => (a.needUpdate === b.needUpdate) ? 0 : a.needUpdate ? -1 : 1);
    }
  }

  getValuesToUpdate() {
    return this.rows.filter(x => x.updatePriceCheck);
  }

  onExport() {
    this.dialogsService.confirm('¿Desea exportar la lista de negocios?',
      'Se exportará la lista de negocios de acuerdo a los filtros actuales',
      'ACEPTAR',
      'CANCELAR')
      .take(1).subscribe(res => {
        if (res) {

          const fechaDesde = this.filters['fecha'] ? this.filters['fecha'].startDate : moment().subtract(this.DEFAULT_DAYS_FILTER, 'days').startOf('day').toDate();
          const fechaHasta = this.filters['fecha'] ? this.filters['fecha'].endDate : moment().endOf('day').toDate();

          this.spinnerService.setShowFlag(true);
          this.negociosService.exportToExcel(
            this.currentPage,
            fechaDesde,
            fechaHasta,
            this.getSortColumnTitle(this.sortColumn),
            this.sortOrder[this.sortColumn],
            this.filters,
            this.quickFiltersModels,
            this.pageSize
          )
            .take(1).subscribe(x => {
              this.spinnerService.setShowFlag(false);
            }, (err) => {
              this.spinnerService.setShowFlag(false);
            });
        }
      });
  }

  onGoToPage(next = true) {
    if (next) {
      if (this.currentPage < this.resultsPageCount - 1) {
        // avanzar pagina
        this.currentPage++;
        this.getNegocios(this.currentPage);
      }
    } else {
      if (this.currentPage > 0) {
        // retroceder pagina
        this.currentPage--;
        this.getNegocios(this.currentPage);
      }
    }
  }

  changePageSize(e) {
    this.currentPage = 0;
    this.getNegocios(this.currentPage);
  }

  disableHightLight() {
    if (this.highLightTimeout != null) {
      clearTimeout(this.highLightTimeout);
    }
    this.highLightTimeout = setTimeout(() => {
      this.rows.forEach(x => {
        if (x.isNew) {
          delete x.isNew;
        }
      });
    }, 20000);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios/negocios.component.ts